'use client'

// src/hooks/useUserSubscription.ts
import { useMemo } from "react";
import { useAuth } from "@wbk/auth";
import { useTranslation } from "@wbk/config";
var useUserSubscription = () => {
  const { user } = useAuth();
  const { t } = useTranslation(["subscription_common"]);
  const subscriptions = useMemo(() => {
    var _a;
    if ((_a = user == null ? void 0 : user.user_subscriptions) == null ? void 0 : _a.length) {
      return user.user_subscriptions;
    }
    return [
      {
        _id: "default",
        plan: {
          _id: "free",
          name: t("subscription_common:free"),
          benefits: [
            { benefit_action_title: "", benefit_action_value: "", benefit_action_id: "", name: "" }
          ],
          plan_group: {
            _id: "free",
            name: t("subscription_common:free")
          }
        }
      }
    ];
  }, [user == null ? void 0 : user.user_subscriptions, t]);
  return {
    subscriptions
  };
};

export {
  useUserSubscription
};
//# sourceMappingURL=chunk-DZQX2LRT.mjs.map